import React from 'react'
import { ArrowProps } from './types';


const Arrow: React.FC<ArrowProps> = ({
  size = 100,
  direction = "left",
  ...props
}) => {
  const isRight = direction === "right";

  return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          transform: isRight ? "scaleX(-1)" : undefined,
          transformOrigin: "center",
        }}
        {...props}
      >
        <path
          className="arrow-path"
          d="M60 20 L30 50 L60 80"
          stroke="currentColor"
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
  );
};

export default Arrow;